import {defineMessages} from 'react-intl';

import {chevronUp, negative} from '@sail/icons/react/Icon';

import {HeaderButton, useAnalytics} from '@stripe-internal/conversations-ui';

const messages = defineMessages({
  open: {
    id: 'conversations_ui.widget.header.openButton.label',
    description:
      'Label used for the header button that takes the widget from a minimized state to an open state.',
    defaultMessage: 'Show',
  },
  minimize: {
    id: 'conversations_ui.widget.header.minimizeButton.label',
    description:
      'Label used for the header button that takes the widget from an open state to a minimized state.',
    defaultMessage: 'Hide',
  },
});

type Props = {
  visibility: 'open' | 'closed' | 'minimized';
  onOpen: () => void;
  onMinimize: () => void;
  disabled?: boolean;
  color?: string;
  hoverColor?: string;
};

export function DotComMinimizeButton({
  visibility,
  onOpen,
  onMinimize,
  disabled = false,
  color,
  hoverColor,
}: Props) {
  const analytics = useAnalytics();

  let label;
  let icon;
  let onToggle;

  if (visibility === 'open') {
    label = messages.minimize;
    icon = negative;
    onToggle = onMinimize;
  } else {
    label = messages.open;
    icon = chevronUp;
    onToggle = onOpen;
  }

  return (
    <HeaderButton
      testId="conversations-widget-header-toggle-button"
      icon={icon}
      label={label}
      onPress={() => {
        if (disabled) {
          return;
        }

        analytics.action('toggle_minimize_button_clicked');
        onToggle();
      }}
      disabled={disabled}
      color={color}
      hoverColor={hoverColor}
      tooltipEnabled={false}
    />
  );
}
